import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import localStorageService from "app/services/localStorageService";
import {
  getSystemConfigId,
  pagingSystemConfig,
  saveOrUpdate,
  deleteById,
  getCheckSystemConfig,
  getByKeyCode,
} from "app/services/SystemConfigService";
import { updateAppConfig } from "app/services/jwtAuthService.js";
import {
  SOLUTION_DEFAULT,
  SystemConfigCode,
  TEST_RESULT_PRINT,
  FEE_VOUCHER_LEGAL_ENTITY_BY_DEPT,
} from "app/common/LocalConst";
import { getFileById } from "app/services/FileDescriptionExtService";

function isNumber(value) {
  return !isNaN(parseFloat(value)) && isFinite(value);
}

const handleAddLocalStorage = async (key, value) => {
  if (!key || !value) return;
  let valueKey = value;

  if (value === "true") {
    valueKey = true;
  }
  if (value === "false") {
    valueKey = false;
  }
  if (isNumber(value)) {
    valueKey = +value;
  }
  if (key === "LOGO") {
    if (value) {
      let { data: img } = await getFileById(value);
      localStorageService.setItem("imgLogo", URL.createObjectURL(img));
    } else {
      localStorageService.setItem("imgLogo", null);
    }
  }
  if (key === "SOLUTION") {
    value = localStorageService.parseJson(value, SOLUTION_DEFAULT);
  }
  const dataConfigLocal = localStorageService.getItem("sysConfig") || {};
  dataConfigLocal[key] = valueKey;
  localStorageService.setItem("sysConfig", dataConfigLocal);
  updateAppConfig(dataConfigLocal);
};

const handleRemoveLocalStorage = (key) => {
  if (!key) return;
  const dataConfigLocal = localStorageService.getItem("sysConfig") || {};
  delete dataConfigLocal[key];
  localStorageService.setItem("sysConfig", dataConfigLocal);
  updateAppConfig(dataConfigLocal);
};

export default class SystemConfigStore {
  listAllGlobalProperty = [];
  searchGlobalProperty = new SearchObject({ pageSize: 50 });
  pageGlobalProperty = null;
  selectedGlobalProperty = null;
  openFormCreateOrEdit = false;
  openConfirmDeleteGlobalProperty = false;

  constructor() {
    makeAutoObservable(this);
  }

  getAllGlobalProperty = async () => {
    if (this.listAllGlobalProperty?.length) return;
    const searchObjectForAll = {
      pageIndex: 1,
      pageSize: 1000000,
    };
    return await pagingSystemConfig(searchObjectForAll)
      .then(({ data }) => {
        this.listAllGlobalProperty = data?.content;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy kiểu dữ liệu của khái niệm có lỗi");
      });
  };

  pagingSystemConfig = () => {
    pagingSystemConfig(this.searchGlobalProperty).then(({ data }) => {
      this.pageGlobalProperty = data;
    });
  };

  handleChangeFormSearch = (searchGlobalProperty) => {
    this.searchGlobalProperty = checkSearchObject(
      this.searchGlobalProperty,
      searchGlobalProperty
    );
    this.pagingSystemConfig();
  };

  handleOpenFormCreateOrEdit = (id) => {
    if (Boolean(id)) {
      getSystemConfigId(id)
        .then(({ data }) => {
          if (data?.configKey === "TEST_RESULT_PRINT") {
            console.log("data", data?.configValue);
            let items = JSON.parse(data?.configValue || "[]")?.map((el) => ({
              key: el?.key,
              value: el?.value === "true" ? true : false,
            }));
            console.log("items", items);
            this.selectedGlobalProperty = { ...data, items };
          } else if (data?.configKey === FEE_VOUCHER_LEGAL_ENTITY_BY_DEPT) {
            let items = [];
            try {
              const parsed = JSON.parse(data?.configValue || "[]");
              items = Array.isArray(parsed) ? parsed : [];
            } catch (e) {
              items = [];
            }
            this.selectedGlobalProperty = { ...data, items };
          } else {
            this.selectedGlobalProperty = data;
          }
          this.openFormCreateOrEdit = true;
        })
        .catch(function (error) {
          toast.error("Lấy dữ liệu có lỗi");
        });
    } else {
      this.selectedGlobalProperty = {
        configKey: "",
        configValue: "",
        note: "",
      };
      this.openFormCreateOrEdit = true;
    }
  };

  saveOrUpdateConfig = async (globalProperty, { setSubmitting }) => {
    if (globalProperty?.configKey === TEST_RESULT_PRINT) {
      let formatItem =
        globalProperty?.items?.length > 0 &&
        globalProperty?.items?.map((el) => ({
          ...el,
          value: el?.value ? "true" : "false",
        }));
      globalProperty.configValue = JSON.stringify(formatItem);
    }
    if (globalProperty?.configKey === FEE_VOUCHER_LEGAL_ENTITY_BY_DEPT) {
      const items = (globalProperty?.items || []).map((el) => ({
        departmentCode: el?.departmentCode?.trim?.() || el?.departmentCode || "",
        legalEntityName: el?.legalEntityName?.trim?.() || el?.legalEntityName || "",
        taxCode: el?.taxCode?.trim?.() || el?.taxCode || "",
        address: el?.address?.trim?.() || el?.address || "",
        phone: el?.phone?.trim?.() || el?.phone || "",
      }));
      globalProperty.configValue = JSON.stringify(items);
    }
    return await saveOrUpdate(globalProperty)
      .then(({ data }) => {
        if (data?.configKey === "TYPE_EXAM") {
          localStorageService.setItem("typeExam", data?.configValue);
        }

        this.selectedGlobalProperty = null;
        toast.success("Lưu thành công");
        handleAddLocalStorage(data?.configKey, data?.configValue);
        this.pagingSystemConfig();
        this.handleClosePopup();
      })
      .catch(function (error) {
        toast.error("Có lỗi xảy ra");
      })
      .finally(function () {
        setSubmitting(false);
      });
  };

  handleCheckKey = async (value) => {
    try {
      const { data } = await getCheckSystemConfig(value);
      return data;
    } catch (error) {
      toast.error("Lưu xảy ra lỗi");
      return true;
    }
  };

  handleDeleteGlobalProperty = (data) => {
    this.selectedGlobalProperty = data;
    this.openConfirmDeleteGlobalProperty = true;
  };

  handleConfirmDeleteGlobalProperty = () =>
    deleteById(this.selectedGlobalProperty?.id)
      .then(() => {
        if (
          this.searchGlobalProperty?.pageIndex > 1 &&
          this.pageGlobalProperty?.content?.length === 1
        ) {
          this.searchGlobalProperty.pageIndex -= 1;
        }
        handleRemoveLocalStorage(this.selectedGlobalProperty?.configKey);
        toast.success("Lưu thành công");
        this.pagingSystemConfig();
        this.handleClosePopup();
      })
      .catch(function (error) {
        console.error(error);
        toast.error("Có lỗi xảy ra");
      });

  handleClosePopup = () => {
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteGlobalProperty = false;
  };

  resetStore = () => {
    this.searchGlobalProperty = new SearchObject();
    this.pageGlobalProperty = null;
    this.selectedGlobalProperty = null;
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteGlobalProperty = false;
  };

  getByKeyCode = async (code) => {
    try {
      const { data } = await getByKeyCode(code);

      return data;
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi xảy ra khi lấy dữ liệu");
    }
  };

  isJsonArray = (str) => {
    try {
      const parsed = JSON.parse(str);
      return Array.isArray(parsed);
    } catch (e) {
      return false;
    }
  };
}
